export function getSystemConfig() {
  // NODE_ENV : development 本地环境 / production 服务器环境(包括测试和正式)
  const DEVELOPMENT = process.env.NODE_ENV === 'development'
  const PRODUCTION = process.env.NODE_ENV === 'production'

  // RELEASE : beta 测试代码 / stable 正式代码
  const BETA = process.env.RELEASE === 'beta'
  const STABLE = process.env.RELEASE === 'stable'

  const host = {
    beta: {
      api: 'https://api-test.yunhzh.com',
      main: 'beta.yunhzh.com',
      en_main: 'en.yunhzh.com',
      supply: 'beta-supply.yunhzh.com',
      en_supply: 'en-supply.yunhzh.com',
    },
    stable: {
      api: 'https://api.yzdli.com',
      main: 'www.yzdli.com',
      en_main: 'en.yzdli.com',
      supply: 'supply.yzdli.com',
      en_supply: 'en-supply.yzdli.com',
    },
  }

  const releaseHost = host[process.env.RELEASE]

  const locales = [
    { lang: 'en', supply: false, domain: releaseHost.en_main },
    { lang: 'zh', supply: false, domain: releaseHost.main },
    { lang: 'en', supply: true, domain: releaseHost.en_supply },
    { lang: 'zh', supply: true, domain: releaseHost.supply },
  ]

  const config = {
    host,
    locale: {
      locales,
      defaultLocale: 'zh',
      cookieLocaleKey: 'i18n_redirected',
    },
    releaseHost,
    envBoolean: {
      DEVELOPMENT,
      PRODUCTION,
      BETA,
      STABLE,
    },
    API_HOST: '/',
    COOKIE_PATH: '/',
  }

  if (BETA) {
    config.API_HOST = host.beta.api
  } else if (STABLE) {
    config.API_HOST = host.stable.api
  }
  return config
}
